<template>
  <v-sheet class="mx-auto pa-3 w-75">
    <p>
      ※イベントチケットでは3Fの試遊・物販会場を一日楽しめます。また、B2Fのイベント会場で行われる各種当日イベントへの参加にも必要です。
    </p>
    <p>※試遊・物販チケットでは、B2Fのイベント会場には入場できません。</p>
    <p>※当日は「THE CAFE」「昭和ブックカフェ」を貸切っての開催となります。</p>
    <p>
      ※カフェは当日のみ完全禁煙となりますのでご了承ください。カフェ内にある喫煙室での喫煙は可能です。
    </p>
    <p>※当日はカフェのフード注文は承っておりません。</p>
    <p>
      ※当日は「THE
      CAFE」「昭和ブックカフェ」の営業時間も11：00～17:00となります。
      イベント開催時間外のカフェのご利用は出来ません。
    </p>
    <p>
      ※商業施設へのご迷惑になりますのでイベント前に店前にて並ぶのはお控えください。
    </p>

    <p>※感染症対策の為、マスクの着用をお願いいたします。</p>
    <p>
      ※荷物のお預かりはしておりません。手荷物や貴重品の管理は各自でお願いいたします。
    </p>
    <p>
      ※会場内におけるトラブル、事故やケガ、盗難、紛失等につきましては、主催者は一切の責任を負いかねます。
    </p>
    <p>
      ※迷惑行為を行ったり、スタッフの指示に従っていただけない場合、退出をお願いすることがあります。
    </p>
    <p>
      ※会場内が混雑してきた際は入れ替え制となる場合がございますので、あらかじめご了承ください。
    </p>
    <p>
      ※現場での撮影・録音は原則禁止です。ゲーム画面の撮影は出展メーカーにご確認をお願いします。
    </p>
  </v-sheet>
</template>
